module.exports = __webpack_public_path__ + "assets/fonts/Guroo-Producer.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/guroo-producer/fonts/Guroo-Producer.ttf
 ** module id = 1088
 ** module chunks = 0
 **/